import { makeBuildHubUrl } from '~/modules/build-hub/utils/url-builder';

import { formatBriefHandle } from '../brief-reference';

/** The member-scoped list, which holds every brief a reader filed. */
export const MEMBER_REQUESTS_PATH = '/app/get-matched-requests';

/** The path segment the project-scoped pages hang off, shared with the left nav config. */
export const PROJECT_REQUESTS_SEGMENT = '/get-matched-requests';

/** A reader's own list of briefs, across every project. */
export const memberRequestsHref = (): string => MEMBER_REQUESTS_PATH;

/** One brief, addressed from the reader's own list. */
export const memberRequestDetailHref = (submissionId: string): string =>
    `${MEMBER_REQUESTS_PATH}/${formatBriefHandle(submissionId)}`;

/**
 * The internal desk that answers briefs.
 *
 * Keeps the slug the Business Manager page used, so the redirect that replaces it is
 * path-for-path and any link an admin has bookmarked still lands in the right place.
 */
export const ADMIN_REQUESTS_PATH = '/app/get-matched-requests-admin';

/** Every brief there is, for the people who answer them. */
export const adminRequestsHref = (): string => ADMIN_REQUESTS_PATH;

/** One brief, addressed from the desk. */
export const adminRequestDetailHref = (submissionId: string): string =>
    `${ADMIN_REQUESTS_PATH}/${formatBriefHandle(submissionId)}`;

/** The briefs filed against one project. */
export const projectRequestsHref = (projectUrlSegment: string): string =>
    makeBuildHubUrl(projectUrlSegment, PROJECT_REQUESTS_SEGMENT);

/** One brief, addressed from inside the project it belongs to. */
export const projectRequestDetailHref = (
    projectUrlSegment: string,
    submissionId: string,
): string =>
    makeBuildHubUrl(
        projectUrlSegment,
        `${PROJECT_REQUESTS_SEGMENT}/${formatBriefHandle(submissionId)}`,
    );

/**
 * Where the reference on the confirmation screen goes.
 *
 * A brief filed against a project is read inside that project, which is where the reader
 * will look for it later. A brief without one — the case that means provisioning failed —
 * stays reachable from the reader's own list, so it is never stranded.
 */
export const briefConfirmationHref = (
    submissionId: string,
    buildHubURLSegment: string | null,
): string =>
    buildHubURLSegment
        ? projectRequestDetailHref(buildHubURLSegment, submissionId)
        : memberRequestDetailHref(submissionId);
